import { IPlanFilterExtraField } from '../interfaces/IPlanFilterExtraField';

export const initialPlanListAdditionalFields: IPlanFilterExtraField[] = [
  {
    id: 'id',
    name: 'Номер плана',
    isSelected: false,
  },
  {
    id: 'statuses',
    name: 'Статус плана',
    isSelected: false,
  },
  {
    id: 'isOnlyDeleted',
    name: 'Показывать только удаленные планы',
    isSelected: false,
  },
  {
    id: 'period',
    name: 'Период действия плана',
    isSelected: false,
  },
];

export const isTestAdditionalField: IPlanFilterExtraField = {
  id: 'isTest',
  name: 'Тестовый',
  isSelected: false,
};
